// components/ContactUsCTA.jsx

import Link from "next/link";
import { useRouter } from "next/router";
import { useDemoPopup, isPopupRoute } from "../context/DemoPopupContext";

export default function ContactUsCTA({
  children,
  className = "",
  as = "link", // "link" or "div"
  location = "hero",
  cluster = "damage-detection",
  type = "request-demo",
  disablePopup = false, // when true, always navigate to /contact-us (never popup)
  ...props
}) {
  const router = useRouter();
  const { openPopup } = useDemoPopup();

  const ctaProps = {
    "data-cta-track": "true",
    "data-cta-location": location,
    "data-cta-cluster": cluster,
    "data-cta-type": type,
  };

  // On popup-enabled routes (everywhere except the excluded pages), open the
  // inline demo popup instead of navigating to /contact-us — unless this CTA
  // opts out via disablePopup (e.g. the "Contact sales" button).
  if (isPopupRoute(router.pathname) && !disablePopup) {
    return (
      <div
        className={className}
        role="button"
        onClick={(e) => {
          e.preventDefault();
          openPopup({ trigger: "button_click" });
        }}
        {...ctaProps}
        {...props}
      >
        {children}
      </div>
    );
  }

  if (as === "div") {
    return (
      <div
        className={className}
        onClick={() => (window.location.href = "/contact-us")}
        {...ctaProps}
        {...props}
      >
        {children}
      </div>
    );
  }

  return (
    <Link
      href="/contact-us"
      className={className}
      {...ctaProps}
      {...props}
    >
      {children}
    </Link>
  );
}
